"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultIsOpenedState = getDefaultIsOpenedState;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
var _hasLanguageInUrl = require("./hasLanguageInUrl");
/**
 * Tells if Language switcher modal should be opened or not.
 * Note: It looks for the `lang` value and ignores old `<tenant>_website#lang`.
 *
 * @param availableLanguages Languages available for current tenant.
 * @returns True if Language switcher modal should be opened, false if not.
 */
function getDefaultIsOpenedState(availableLanguages) {
  const languageCookieValue = _jsCookie.default.get(_constants.LANGUAGE_COOKIE_KEY);

  // Don't show modal since there is only one language available or don't show language if its already in url
  if (availableLanguages.length < 2 || (0, _hasLanguageInUrl.hasLanguageInUrl)(availableLanguages)) {
    return false;
  }

  // Show modal since language cookie has not yet been set.
  return typeof languageCookieValue == 'undefined';
}